import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { todosFeatureKey } from '../key';
import type { NodeTodosQueryParams } from './useNodeTodosQuery';

const localKey = ['node-todos'] as const;

type NodeTodosListQueryType = GenericListQueryKey<NodeTodosQueryParams['filter']>;

const getNodeTodosListQueryKey = (params: NodeTodosListQueryType) =>
  generateListQueryKey({
    prefix: [...todosFeatureKey, ...localKey],
  })(params);

export const getNodeTodosInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getNodeTodosListQueryKey,
});
